export default "__VITE_ASSET__14239df2__"